<template>
    <el-card shadow="never" class="aui-card--fill">
        <div class="mod-sys__user">
            <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
            </el-form>
            <el-table v-loading="dataListLoading"  :data="dataList"  @selection-change="dataListSelectionChangeHandle"
                      @sort-change="dataListSortChangeHandle" row-key="id" border style="width: 100%;">
                <el-table-column prop="orgNo" :label="$t('org.orgNo')" sortable="custom" header-align="center"
                                 align="center"></el-table-column>
                <el-table-column prop="orgName" :label="$t('org.orgName')" header-align="center"
                                 align="center"></el-table-column>
                <el-table-column prop="memberNum" label="用户数" sortable="custom" header-align="center"
                                 align="center">
                </el-table-column>
                <el-table-column prop="cloundNum" label="云客数" sortable="custom" header-align="center"
                                 align="center">
                </el-table-column>
                <el-table-column prop="parnterNum" label="合伙人数" sortable="custom" header-align="center"
                                 align="center">
                </el-table-column>
                <el-table-column prop="deviceNum" label="节点数" sortable="custom" header-align="center"
                                 align="center">
                </el-table-column>
            </el-table>
            <el-pagination
                    :current-page="page"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="limit"
                    :total="total"
                    layout="total, sizes, prev, pager, next, jumper"
                    @size-change="pageSizeChangeHandle"
                    @current-change="pageCurrentChangeHandle">
            </el-pagination>
        </div>
    </el-card>
</template>

<script>
    import mixinViewModule from '@/mixins/view-module';

    export default {
        mixins: [mixinViewModule],
        data() {
            return {
                mixinViewModuleOptions: {
                    getDataListURL: '/sys/org/orgSalePage',
                    getDataListIsPage: true,
                    deleteIsBatch: true,
                    deleteURL: '/sys/org'
                }
            }
        }
    }
</script>
